import React from 'react'
import PropTypes from 'prop-types'

const BusinessSectionTopSubtitle = ({ subtitle }) => {
  if (!subtitle) return null

  return <p className="f8 f7-m f6-l lh-title tc mv0 fw3">{subtitle}</p>
}

BusinessSectionTopSubtitle.propTypes = {
  subtitle: PropTypes.node
}

export default BusinessSectionTopSubtitle



// WEBPACK FOOTER //
// ./src/components/business-section/business-section-top/business-section-top-subtitle.js